import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from 'admin-on-rest';

import { API_ROOT } from './apiConfig';

import Cookies from 'js-cookie';

export default (type, params) => {
  // called when the user attempts to log in
  if (type === AUTH_LOGIN) {
    const csrftoken = Cookies.get('csrftoken');
    const { username, password } = params;
    const request = new Request(`${API_ROOT}/accounts/staff-login/`, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({ username, password }),
      headers: new Headers(
        { 'Content-Type': 'application/json', 
        'Cache': 'no-cache',
        'X-CSRFToken': csrftoken }),
    })
    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
      })
      .then(() => {
        localStorage.setItem('username', username);
        return Promise.resolve();
      });
  }
  // called when the user clicks on the logout button
  if (type === AUTH_LOGOUT) {
    const request = new Request(`${API_ROOT}/accounts/staff-logout/`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
    })
    return fetch(request)
      .then(() => {
        localStorage.removeItem('username');
        return Promise.resolve();
      });
  }
  // called when the API returns an error
  if (type === AUTH_ERROR) {
    const { status } = params;
    if (status === 401 || status === 403) {
      localStorage.removeItem('username');
      return Promise.reject();
    }
    return Promise.resolve();
  }
  // called when the user navigates to a new location
  if (type === AUTH_CHECK) {
    return localStorage.getItem('username') ? Promise.resolve() : Promise.reject();
  }
  return Promise.reject('Unknown method');
};



// WEBPACK FOOTER //
// ./src/api/authClient.js